module.exports = __webpack_public_path__ + "static/img/祁老师 雕塑泥塑.bdcb9859.png";